import axios from 'axios'

export function fetchInternalArticles () {
  return axios.get('/internal-articles')
}
